import React, {useEffect, useState} from 'react';
import {USER_ROLE} from "@app/constants/Common";
import {requestGetJobHideUser} from "@app/services/JobService";
import Select from "react-select";
import {requestGetUserList} from "@app/services/UserService";
import {callApiSaveJob} from "@pages/job/common/Services";

const JobPermissionContent = (props) => {
    const [jobHideUser, setJobHideUser] = useState({job_id: '', hide_users: []});
    const [isFetchingUser, setFetchingUser] = useState(false);
    const [userOptions, setUserOptions] = useState([]);

    const {onChange} = props
    const {jobId} = props

    const fetchUsers = async () => {
        setFetchingUser(true)
        const res = await requestGetUserList({});
        setFetchingUser(false)
        const userList = res.content.users
        const userOptionList = []
        userList.forEach(user => {
            if (user.groups && user.groups !== USER_ROLE.ADMIN) {
                userOptionList.push({value: user.id, label: user.email})
            }
        })
        setUserOptions(userOptionList);
    };
    // useEffect(() => {
    //     if (!isFetchingUser) {
    //         fetchUsers()
    //     }
    //
    // },[]);

    const fetchJobHideUsers = async () => {
        if (jobId) {
            const res = await requestGetJobHideUser({job_id: jobId})
            jobHideUser.hide_users = res.content.map(item => {
                return {value: item.user_id, label: item.user_email}
            })
            setJobHideUser({...jobHideUser})
        }
    };

    const fetchDataInit = async () => {
        if (userOptions.length === 0) {
            await fetchUsers()
        }
        await fetchJobHideUsers()
    }
    useEffect(async () => {
        jobHideUser.job_id = jobId
        await fetchDataInit()
    },[jobId]);

    const onSave= () => {
        const body = {job_id: jobHideUser.job_id}
        body.hide_user_ids = jobHideUser.hide_users.map(item => {
            return item.value
        })
        callApiSaveJob(body,  (res) => {
            const newJob = res.content
            jobHideUser.job_id = newJob.id
            setJobHideUser({...jobHideUser})
        })
    }

    const onSelectMultiUsers = (values) => {
        jobHideUser.hide_users = values
        setJobHideUser({...jobHideUser});
        if (onChange) {
            onChange(jobHideUser)
        }
    };

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Phân quyền</h3>
                <div className='card-tools'>
                    <button type='button' className='btn btn-primary'
                            onClick={() => onSave()}>Save
                    </button>
                </div>
            </div>
            <div className='card-body'>
                <div>
                    <label>Users hide job</label>
                    <Select options={userOptions}
                            isMulti
                            placeholder={"Chọn users"}
                            value={jobHideUser.hide_users}
                            onChange={values => {
                                onSelectMultiUsers(values);
                            }}
                    />
                </div>
            </div>
        </div>
    )
}

export default JobPermissionContent;
